import { render, staticRenderFns } from "./HistoricVideoRequest.vue?vue&type=template&id=fba41be8"
import script from "./HistoricVideoRequest.js?vue&type=script&lang=js&external"
export * from "./HistoricVideoRequest.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports